import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { FullScreenService } from '@y42/services/full-screen';
import { SidebarService } from './sidebar.service';

@UntilDestroy()
@Component({
  selector: 'y42-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  constructor(private readonly sidebarService: SidebarService, private readonly fullScreenService: FullScreenService) {}

  readonly state = connectState(this, {
    isFullScreen: this.fullScreenService.isFullScreen$,
    sidebarOpen: this.sidebarService.isOpen$,
  });

  closeSidebar() {
    this.sidebarService.close();
  }
}
